module.exports = __webpack_public_path__ + "static/SharpSansNo1-Bold-cda30daca363255da10a85542486b176.ttf";